import React, {Component} from 'react';
import styles from './TrackSection.scss';
import classNames from 'classnames/bind';
import {observable, action} from 'mobx';
import {observer} from 'mobx-react';
import ScrollMagic from "scrollmagic";
import graphHeader from 'assets/images/awair/graph-header.svg';
import graphBackground from 'assets/images/awair/graph-bg.svg';
import graphHighLabel from 'assets/images/awair/graph-high-label.svg';
import graphLowLabel from 'assets/images/awair/graph-low-label.svg';
import graphFooter from 'assets/images/awair/graph-footer.svg';

const cx = classNames.bind(styles);

class TrackStore {
  @observable transitionHidden = false;
  @observable graphUnhidden = false;

  @action activeTransitionHidden = () => this.transitionHidden = true;
  @action unactiveTransitionHidden = () => this.transitionHidden = false;
  @action activeGraphUnhidden = () => this.graphUnhidden = true;
  @action unactiveGraphUnhidden = () => this.graphUnhidden = false;
}

const trackStore = new TrackStore();

@observer
class TrackSection extends Component {
  trackSectionRef;

  handleSceneAnimation = () => {
    const {trackSectionRef} = this;
    const {
      activeTransitionHidden,
      unactiveTransitionHidden,
      activeGraphUnhidden,
      unactiveGraphUnhidden
    } = trackStore;

    const trackController = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerElement: trackSectionRef,
      triggerHook: 'onEnter',
      duration: '100%',
      offset: window.innerHeight * 0.25
    })
      .on('enter', () => {
        activeTransitionHidden();
        activeGraphUnhidden();
      })
      .on('leave', () => {
        unactiveTransitionHidden();
        unactiveGraphUnhidden();
      })
      .addTo(trackController);
  };

  componentDidMount() {
    this.handleSceneAnimation();
  }

  render() {
    const {transitionHidden, graphUnhidden} = trackStore;

    return (
      <section className={cx('track')} ref={ref => this.trackSectionRef = ref}>
        <div className={cx('track-backdrop')} />
        <div className={cx('track-transition', transitionHidden && 'track-transition-hidden')}>
          <p>空気がどれほど改善されたのか、グラフを通して簡単に知ることができます。</p>
        </div>
        <div className={cx('track-foreground')} id='track-foreground'>
          <div className={cx('graph', graphUnhidden && 'unhidden')} id='graph'>
            <img src={graphHeader} className={cx('graph-header', 'graph-header-svg')} id="graph-header-svg" alt='graph header' />
            <img src={graphBackground} className={cx('graph-bg')} id='graph-bg-svg' alt='graph background' />
            <svg className={cx('graph-line-svg')} width="370" height="98" viewBox="0 0 370 98" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="gl-svg-gradient">
                  <stop stopColor="#F29C33" offset="0%" />
                  <stop stopColor="#F9C933" offset="53.059%" />
                  <stop stopColor="#AFD819" offset="100%" />
                </linearGradient>
                <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="gl-svg-filter">
                  <feGaussianBlur stdDeviation="2" in="SourceGraphic" />
                </filter>
              </defs>
              <path id="graph-line-shadow-path" className={cx('graph-line-shadow-path')} filter="url(#gl-svg-filter)"
                    d="M5 180.247l5.3-4.613 4.42-1.79 3.666-1.024 2.223 1.917 3.118-7.873 2.956 1.534 2.66.17.997-4.053 2.916 2.824 2.805-3.093 3.625-1.472 4.57.337 4.67-5.623 2.86 1.53 3.026-3.183 2.7 2.64 1.23-4.624 3-1.67 2.88 3.468 3.27-3.104 3.19 2.858 7.237-.795 3.26-1.946 2.777 1.958 2.514-1.59 4.43.503 2.878-4.895 4.127 3.005 2.324-3.713 2.166 2.79 4.262-.66 2.073-4.212 2.768 2.346.865-3.466 2.54.706 3.734-2.436 2.478 6.457 3.908 3.887 2.738-.908 1.74 3.588 2.467-2.332 1.82 2.375 2.476-7.51 3.314 9.976 3.54-12.713 2.042 3.207 3.18.788 3.183 4.804 3.45 2.995 3.688 3.17 1.747 3.748 3.253-.84 1.75 5.15 2.84 1.53 4.57 1.465 3.765.977 2.206-2.765 2.775 2.344 3.443-.997 3.764 3.584 3.323-1.562 2.254 3.3 2.426-.422 2.316 1.594 4.748.082 4.047-2.685 4.19 2.75 3.703.515 3.99 3.763 4.192 1.16 2.626 4.438 4.623-.428 2.97 3.16 3.573 1.674 1.416 4.572 3.65 4.85 3.55 3.758 3.77 17.21 3.16-.51 1.787 3.065 4.633-.375 1.575 3.965 3.1 2.247 3.21 1.264 3.886-2.75.836 3.632 3.03-4.307 3.663 3.84 3.84 4.22 2.88-8.145 4.218-5.05 3.412-4.082 1.044-9.406 1.97-8.25 2.86-4.753 3.44-2.104 3.177-1.71h4.812l2.188-2.856 4.81 2.856 5.082-4.97 1.98 3.276 3.875-3.277 3.874.185 5.908-4.917 2.77 2.46 2.536-1.435 3.157-1.653 2.165 1.6 3.09-3 1.893 4.038 2.254-2.444 4.287 1.46 3.5-3.824H371"
                    transform="translate(1 -137)" stroke="#000" strokeWidth="4" fill="none" fillRule="evenodd"
                    strokeOpacity=".15" strokeLinecap="round" strokeLinejoin="round" />
              <path id="graph-line-path" className={cx('graph-line-path')}
                    d="M5 177.247l5.3-4.613 4.42-1.79 3.666-1.024 2.223 1.917 3.118-7.873 2.956 1.534 2.66.17.997-4.053 2.916 2.824 2.805-3.093 3.625-1.472 4.57.337 4.67-5.623 2.86 1.53 3.026-3.183 2.7 2.64 1.23-4.624 3-1.67 2.88 3.468 3.27-3.104 3.19 2.858 7.237-.795 3.26-1.946 2.777 1.958 2.514-1.59 4.43.503 2.878-4.895 4.127 3.005 2.324-3.713 2.166 2.79 4.262-.66 2.073-4.212 2.768 2.346.865-3.466 2.54.706 3.734-2.436 2.478 6.457 3.908 3.887 2.738-.908 1.74 3.588 2.467-2.332 1.82 2.375 2.476-7.51 3.314 9.976 3.54-12.713 2.042 3.207 3.18.788 3.183 4.804 3.45 2.995 3.688 3.17 1.747 3.748 3.253-.84 1.75 5.15 2.84 1.53 4.57 1.465 3.765.977 2.206-2.765 2.775 2.344 3.443-.997 3.764 3.584 3.323-1.562 2.254 3.3 2.426-.422 2.316 1.594 4.748.082 4.047-2.685 4.19 2.75 3.703.515 3.99 3.763 4.192 1.16 2.626 4.438 4.623-.428 2.97 3.16 3.573 1.674 1.416 4.572 3.65 4.85 3.55 3.758 3.77 17.21 3.16-.51 1.787 3.065 4.633-.375 1.575 3.965 3.1 2.247 3.21 1.264 3.886-2.75.836 3.632 3.03-4.307 3.663 3.84 3.84 4.22 2.88-8.145 4.218-5.05 3.412-4.082 1.044-9.406 1.97-8.25 2.86-4.753 3.44-2.104 3.177-1.71h4.812l2.188-2.856 4.81 2.856 5.082-4.97 1.98 3.276 3.875-3.277 3.874.185 5.908-4.917 2.77 2.46 2.536-1.435 3.157-1.653 2.165 1.6 3.09-3 1.893 4.038 2.254-2.444 4.287 1.46 3.5-3.824H371"
                    transform="translate(-3 -138)" strokeWidth="4" stroke="url(#gl-svg-gradient)" fill="none"
                    fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            <img src={graphHighLabel} className={cx('graph-high-label', 'graph-high-label-svg')} id="graph-high-label-svg" alt='graph high label' />
            <img src={graphLowLabel} className={cx('graph-low-label', 'graph-low-label-svg')} id="graph-low-label-svg" alt='graph low label' />
            <img src={graphFooter} className={cx('graph-footer', 'graph-footer-svg')} id="graph-footer-svg" alt='graph footer' />
          </div>
        </div>
      </section>
    );
  }
}

export default TrackSection;


// WEBPACK FOOTER //
// ./src/app/components/organisms/TrackSection/TrackSection.js